import { apiRequest, errorMessage } from "../../api";

// Opens (or creates) the chat with another member and goes to it. Resolves to an error message, or "" when
// the navigation happened. Buyers can message any seller; a seller can message a buyer once they applied.
export async function openChat(userId, navigate, firstMessage = "") {
  const { ok, data } = await apiRequest("/core/cowork/chats/", {
    method: "POST", auth: true, body: { with: userId, ...(firstMessage ? { message: firstMessage } : {}) },
  });
  if (!ok) return errorMessage(data);
  navigate(`/co-work/messages?c=${data.id}`);
  return "";
}
